export enum ResourceTypeEnum {
	SPACE = 'space',
	INSTRUCTOR = 'instructor',
}
